// Loads one game day of gate data: the same request and shape the gates game-day view uses.
import moment from 'moment';
import { getGatesAPI } from './dummyLiveData.js';

export const fetchGatesDay = (currentLocation, authCtx, date) =>
  new Promise((resolve, reject) => {
    // Same as util's getQueuesAPI unless dummy data mode is on (local dev only)
    getGatesAPI(currentLocation)(
      'get-gates-location-daily-data',
      {
        timezone: currentLocation.timeZone,
        gates: currentLocation.gates.map((gate) => ({
          ...gate,
          entranceSensorIds: gate.multiSensor?.queue_time?.components?.ema_rate?.sensorIds || [],
        })),
        venue: authCtx.venue,
        locationId: currentLocation.id,
        measurement: currentLocation.measurement,
        queueMeasurement: currentLocation.queueMeasurement || '',
        date: moment(date).format('YYYY-MM-DD'),
      },
      (data, error) => {
        if (error) {
          reject(error);
          return;
        }
        resolve(currentLocation.gates.map((gate) => {
          const key = String(gate.gateId);
          return {
            id: gate.gateId,
            label: gate.label,
            imageURL: gate.imageURL || null,
            entranceSensorIds: gate.multiSensor?.queue_time?.components?.ema_rate?.sensorIds || [],
            queueIds: gate.queueIds || [],
            totalExits: data?.[key]?.totalExits || 0,
            totalEntrances: data?.[key]?.totalEntrances || 0,
            rawData: data?.[key]?.data || [],
            queueData: data?.[key]?.queueData || [],
          };
        }));
      },
      authCtx.token
    );
  });
